var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 175.78 50.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.23,50.38h1.13V46H46v1.33h1.79a1.75,1.75,0,0,1-1.92,1.75c-1.6,0-2.2-1.36-2.2-2.71s.6-2.78,2.2-2.78A1.67,1.67,0,0,1,47.54,45h1.7a3.26,3.26,0,0,0-3.41-2.85c-2.51,0-4,1.87-4,4.27a3.9,3.9,0,0,0,4,4.2,2.73,2.73,0,0,0,2.22-1.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.8 50.38 56.52 50.38 56.52 48.88 52.58 48.88 52.58 42.29 50.8 42.29 50.8 50.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57,50.38h1.8l.64-1.8h3l.61,1.8h1.85l-3-8.09H60.06Zm4-6.1h0l1,3h-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.1,47.69c0,2,1.65,2.88,3.44,2.88,2.2,0,3.37-1.11,3.37-2.59,0-1.84-1.82-2.21-2.4-2.36-2-.52-2.42-.6-2.42-1.22s.66-.92,1.23-.92c.85,0,1.54.25,1.59,1.22h1.73c0-1.87-1.56-2.6-3.25-2.6-1.46,0-3,.79-3,2.45s1.21,2,2.41,2.29,2.41.47,2.41,1.34-1,1-1.58,1c-1,0-1.79-.42-1.79-1.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "72.96 50.38 74.74 50.38 74.74 46.89 78.01 46.89 78.01 50.38 79.79 50.38 79.79 42.29 78.01 42.29 78.01 45.39 74.74 45.39 74.74 42.29 72.96 42.29 72.96 50.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.17,41.38H86.7V40.06H85.17Zm-2.33,0h1.53V40.06H82.84Zm5.38.91H86.44v5c0,1.2-.41,1.76-1.68,1.76-1.44,0-1.66-.88-1.66-1.76v-5H81.32v5c0,2.2,1.27,3.25,3.44,3.25s3.46-1.06,3.46-3.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "91.88 50.38 93.65 50.38 93.65 43.79 96.08 43.79 96.08 42.29 89.45 42.29 89.45 43.79 91.88 43.79 91.88 50.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.02 50.38 100.8 50.38 100.8 43.79 103.22 43.79 103.22 42.29 96.6 42.29 96.6 43.79 99.02 43.79 99.02 50.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.49 50.38 110.63 50.38 110.63 48.88 106.27 48.88 106.27 46.9 110.19 46.9 110.19 45.52 106.27 45.52 106.27 43.79 110.54 43.79 110.54 42.29 104.49 42.29 104.49 50.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "112.17 50.57 113.46 50.57 116.62 42.1 115.33 42.1 112.17 50.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.22,47.69c0,2,1.65,2.88,3.44,2.88,2.2,0,3.37-1.11,3.37-2.59,0-1.84-1.82-2.21-2.41-2.36-2-.52-2.41-.6-2.41-1.22s.66-.92,1.22-.92c.86,0,1.55.25,1.6,1.22h1.72c0-1.87-1.55-2.6-3.24-2.6-1.46,0-3,.79-3,2.45s1.21,2,2.41,2.29,2.4.47,2.4,1.34-1,1-1.57,1c-1,0-1.79-.42-1.79-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.21,50.38H126l.63-1.8h3l.61,1.8h1.84l-3-8.09h-1.82Zm4-6.1h0l1,3h-2.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 132.96,
    y: 48.63,
    width: 1.78,
    height: 1.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.02 36.36 57.85 36.36 57.85 26.72 57.89 26.72 61.25 36.36 63.58 36.36 66.95 26.63 66.98 26.63 66.98 36.36 69.81 36.36 69.81 22.63 65.56 22.63 62.52 32.07 62.48 32.07 59.27 22.63 55.02 22.63 55.02 36.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.56,21.09h2.6V18.84h-2.6Zm-4,0h2.59V18.84H74.6Zm9.14,1.53h-3v8.55c0,2-.7,3-2.85,3-2.44,0-2.83-1.47-2.83-3V22.62H72v8.55c0,3.73,2.16,5.52,5.85,5.52s5.87-1.81,5.87-5.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "85.94 36.36 88.96 36.36 88.96 30.44 94.52 30.44 94.52 36.36 97.54 36.36 97.54 22.63 94.52 22.63 94.52 27.9 88.96 27.9 88.96 22.63 85.94 22.63 85.94 36.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.61 36.36 109.33 36.36 109.33 33.82 102.64 33.82 102.64 22.63 99.61 22.63 99.61 36.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "111.21 36.36 121.63 36.36 121.63 33.82 114.22 33.82 114.22 30.46 120.88 30.46 120.88 28.11 114.22 28.11 114.22 25.17 121.48 25.17 121.48 22.63 111.21 22.63 111.21 36.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.18 44.66 8.56 43.18 3.75 38.7 3.77 38.67 11.37 40.17 12.84 38.59 5.66 31.89 4.28 33.37 9.1 37.87 9.08 37.89 1.46 36.39 0 37.96 7.18 44.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.48,38l1.65-1.43-.86-2.16L17.05,32l2,1.17,1.69-1.47-9.21-5L9.85,28.14Zm-1.24-8.73,0,0,3.3,1.91-1.92,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.56,18.59l-1.79,1.2,3.42,5.07c.81,1.21.78,2-.5,2.9-1.44,1-2.27.26-2.87-.63l-3.41-5.07-1.79,1.21L19,28.33c1.49,2.21,3.48,2.41,5.67.94s2.75-3.42,1.27-5.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "31.23 24.79 33.12 23.74 29.23 16.74 31.81 15.31 30.93 13.73 23.89 17.63 24.77 19.21 27.35 17.79 31.23 24.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.95,
    y: 12.24,
    width: 2.16,
    height: 9.82,
    transform: "translate(-3.97 17.77) rotate(-27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.87,17.53c.92,2.24,3.21,2.43,5.21,1.58,2.46-1,3.24-2.84,2.53-4.49-.87-2.06-3.07-1.61-3.8-1.5-2.51.38-3,.48-3.27-.22s.29-1.34.93-1.61c1-.4,1.84-.45,2.36.61l1.93-.81c-.89-2.09-3-2.18-4.86-1.38-1.63.69-3,2.32-2.22,4.17.72,1.7,2.3,1.64,3.79,1.43s2.9-.62,3.32.35-.59,1.58-1.28,1.87c-1.07.46-2.2.39-2.72-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54,8a4,4,0,0,0-5.13-2c-2.89.94-3.89,3.65-3,6.42s3.28,4.3,6.17,3.36a4.14,4.14,0,0,0,2.87-5.15l-2,.64A2.21,2.21,0,0,1,51.49,14c-1.84.6-3.05-.74-3.55-2.3s-.35-3.43,1.49-4a2.14,2.14,0,0,1,2.58,1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.16 13.92 59.26 13.4 58.23 9.29 62.09 8.33 63.12 12.44 65.21 11.92 62.83 2.39 60.74 2.91 61.65 6.57 57.79 7.53 56.88 3.87 54.79 4.39 57.16 13.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.91 11.62 74.25 10.31 73.93 8.53 68.71 9.46 68.29 7.09 72.98 6.25 72.68 4.6 68 5.43 67.63 3.36 72.73 2.46 72.42 0.67 65.18 1.96 66.91 11.62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 81.59,
    y: 0.04,
    width: 2.16,
    height: 9.82,
    transform: "translate(-0.12 2.83) rotate(-1.96)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86 9.88 88.02 9.92 88.14 3.34 88.17 3.34 92.13 9.99 94.29 10.03 94.46 0.21 92.44 0.17 92.33 6.76 92.3 6.76 88.32 0.1 86.17 0.06 86 9.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.77,6.82c-.24,2.41,1.7,3.66,3.86,3.85,2.66.23,4.19-1,4.35-2.78.19-2.22-2-2.87-2.66-3.11-2.4-.84-2.85-1-2.79-1.73s.89-1,1.58-1c1,.09,1.84.46,1.8,1.65L104,3.9c.19-2.26-1.61-3.32-3.65-3.5C98.58.25,96.61,1,96.44,3c-.17,1.84,1.25,2.53,2.67,3S102,6.9,101.87,8s-1.26,1.12-2,1.06c-1.15-.11-2.12-.7-2-2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "106.82 11.35 108.94 11.72 110.34 3.84 113.23 4.35 113.55 2.56 105.63 1.17 105.31 2.96 108.21 3.47 106.82 11.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.6,12.39l2.1.53.93-3.73,2.09.53c1.06.26,1.34.8,1.23,1.83a10.71,10.71,0,0,0-.23,2.37l2.09.52a5.49,5.49,0,0,1,.16-2.35,2.23,2.23,0,0,0-.83-2.58v0a2.41,2.41,0,0,0,2.1-2,2.69,2.69,0,0,0-2.13-3.32L115,2.87ZM116.67,5l2.29.57c.94.23,1.35.76,1.12,1.68s-.85,1.23-1.79,1L116,7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.85,8l-2.06-.67-1.88,5.81c-.45,1.39-1.13,1.88-2.6,1.4-1.66-.54-1.6-1.63-1.26-2.65l1.88-5.81-2.05-.67L123,11.2c-.82,2.54.25,4.23,2.76,5.05s4.39.06,5.21-2.46Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "131.4 18.03 133.24 18.85 136.05 12.55 136.07 12.57 135.47 19.84 136.99 20.52 142.02 15.14 142.04 15.15 139.21 21.51 141.06 22.33 145.06 13.36 142.28 12.12 137.54 17.41 137.52 17.4 138.17 10.29 135.39 9.06 131.4 18.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.47 23.31 148.86 27.15 149.79 25.6 145.25 22.87 146.49 20.81 150.57 23.26 151.44 21.82 147.35 19.37 148.44 17.56 152.89 20.23 153.82 18.68 147.53 14.89 142.47 23.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "149.95 27.82 151.59 29.01 155.45 23.69 155.47 23.71 154.91 31.43 156.66 32.7 162.43 24.75 160.8 23.56 156.93 28.89 156.9 28.88 157.46 21.14 155.72 19.88 149.95 27.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "159.46 35.09 161.06 36.53 166.42 30.59 168.6 32.55 169.82 31.2 163.84 25.82 162.63 27.17 164.81 29.14 159.46 35.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "163.58 38.94 168.67 44.39 170 43.15 166.38 39.28 168.14 37.63 171.39 41.12 172.62 39.97 169.37 36.49 170.91 35.05 174.45 38.85 175.78 37.61 170.77 32.24 163.58 38.94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvgWhite);
export default __webpack_public_path__ + "static/media/Logo_SVG_White.12aeb7be9cf0ab914124298db685b0d3.svg";
export { ForwardRef as ReactComponent };